// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"157ce4a4","150":"78f9dc5f","406":"af772f3e","814":"b5831ce9","854":"679e9adf","953":"b19958fd","978":"927ef4b7"}[chunkId] + ".chunk.js";
};